import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PatchPoolDto } from '../../types/pool-plans.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useUpdate = () => {
  const { mutate: update, isPending } = useAppMutation([QueryKey.PATCH_POOL], {
    mutationFn: ({
      companyId,
      data,
      poolId,
    }: {
      companyId: string;
      data: PatchPoolDto;
      poolId: string;
    }) =>
      ApiService.patch(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'pools', poolId] },
        { body: data },
      ),
  });
  return { update, isPending };
};
